"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _materialUiPhoneNumber = _interopRequireDefault(require("material-ui-phone-number"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _constanst = require("../../../utils/constanst");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var styles = {
  container: {
    diaplay: "flex",
    flex: 1,
    position: "relative",
    marginTop: 5
  }
};

var Phone = function Phone(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var handleChange = function handleChange(value) {
    props.handleChange(props.fieldId, value);

    if (!props.field.allowNull && value === "") {} else if (props.field.customValidation) {
      if (!props.isValid(props.field, value)) {} else {}
    } else {
      var valid = value === "+" ? true : false;
      setError(valid);
    }
  };

  (0, _react.useEffect)(function () {
    if (props.field.hasError) {
      setError(true);
    }
  }, [props.field.hasError]);
  var defaultStyles = styles.field;
  var style = !props.field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(props.field.customStyles);
  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement(_materialUiPhoneNumber.default, {
    name: props.field.name || "",
    id: props.fieldId || "",
    label: props.label,
    "data-cy": "user-phone",
    defaultCountry: "ve",
    value: props.defaultValue,
    onChange: handleChange,
    autoFormat: false,
    error: error,
    style: style
  }), /*#__PURE__*/React.createElement(_FormHelperText.default, {
    error: error
  }, error ? _constanst.MSG_REQUIRED : props.field.placeholder));
};

var _default = Phone;
exports.default = _default;